import { PaletteOptions } from '@mui/material/styles/createPalette'
import { pink } from '@mui/material/colors'

export default <PaletteOptions>{
  background: {
    default: pink['50'],
  },
}
